import React from 'react';
import RebelVillaList from './rebel-villa-list';
import RebelConfigList from './rebel-config-list';

const RebelSettingsList = ({ activeTab }) => {
    return (
        <React.Fragment>
            {activeTab === 'properties' && <RebelVillaList />}
            {activeTab === 'config' && <RebelConfigList />}
        </React.Fragment>
    );
}

export default RebelSettingsList;
